import React, { useEffect } from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { WhoFor } from './components/TargetAudience';
import { Problem } from './components/Problem';
import { Agitation } from './components/Agitation';
import { Solution } from './components/Solution';
import { Author } from './components/Author';
import { Modules } from './components/Modules';
import { Preview } from './components/Preview';
import { Bonus } from './components/Bonus';
import { SocialProof } from './components/SocialProof';
import { Pricing } from './components/Pricing';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { StickyMobileCTA } from './components/StickyMobileCTA';
import { FloatingCTA } from './components/FloatingCTA';
import { ThankYou } from './components/ThankYou';
import { initPixel } from './lib/pixel';
import { bootPerf } from './lib/perf';
export function App() {
  const isThankYou = typeof window !== 'undefined' && /^\/(gracias|thank-you|compra-exitosa)\/?$/i.test(window.location.pathname);
  useEffect(() => {
    bootPerf();
    initPixel();
  }, []);
  if (isThankYou) {
    return <ThankYou data-id="element-0" />;
  }
  return <div className="min-h-screen flex flex-col" data-id="element-1">
      <Navbar data-id="element-2" />
      <main className="flex-grow" data-id="element-3">
        <Hero data-id="element-4" />
        <div className="cv-auto" data-id="element-5">
          <WhoFor data-id="element-6" />
        </div>
        <div className="cv-auto" data-id="element-7">
          <Problem data-id="element-8" />
        </div>
        <div className="cv-auto" data-id="element-9">
          <Agitation data-id="element-10" />
        </div>
        <div className="cv-auto" data-id="element-11">
          <Solution data-id="element-12" />
        </div>
        <div className="cv-auto" data-id="element-13">
          <Author data-id="element-14" />
        </div>
        <div className="cv-auto" data-id="element-15">
          <Modules data-id="element-16" />
        </div>
        <div className="cv-auto" data-id="element-17">
          <Preview data-id="element-18" />
        </div>
        <div className="cv-auto" data-id="element-19">
          <Bonus data-id="element-20" />
        </div>
        <div className="cv-auto" data-id="element-21">
          <SocialProof data-id="element-22" />
        </div>
        <div className="cv-auto" data-id="element-23">
          <Pricing data-id="element-24" />
        </div>
        <div className="cv-auto" data-id="element-25">
          <Guarantee data-id="element-26" />
        </div>
        <div className="cv-auto" data-id="element-27">
          <FAQ data-id="element-28" />
        </div>
        <div className="cv-auto" data-id="element-29">
          <FinalCTA data-id="element-30" />
        </div>
      </main>
      <div className="cv-auto" data-id="element-31">
        <Footer data-id="element-32" />
      </div>
      <StickyMobileCTA data-id="element-33" />
      <FloatingCTA data-id="element-34" />
    </div>;
}